import type { MiddlewareContext } from "@/router/index";
import { createNotification } from "@/tools/notification";

export default async function claim(context: MiddlewareContext) {
  const { next } = context;
  const { useUser } = await import("@/stores/user/user");

  if (context.to.meta.claim) {
    const userStore = useUser();

    const hasClaim = userStore.hasClaim(+context.to.meta.claim);

    if (!hasClaim) {
      createNotification("warning", "У Вас нет доступа к этому разделу");
      return next({ name: "profile" });
    }
  }

  return next();
}
